const angular = require('angular');

const { sortByKeys } = require('./tile-list-sort-by-keys.constants');
const { tileListViewLayout } = require('./tile-list-view-layout.constants');
const { ghostTileComponentDefinition } = require('./ghost-tile.component');
const { ghostListComponentDefinition } = require('./ghost-list.component');
const { tileListComponentDefinition } = require('./tile-list.component');
const { tileListWithContentComponentDefinition } = require('./tile-list-with-content.component');
const { tileComponentDefinition } = require('./tile.component');
const { productFilterComponentDefinition } = require('./filter/product-filter.component');
const { stringFilterComponentDefinition } = require('./filter/string-filter.component');
const { selectedFiltersComponentDefinition } = require('./filter/selected-filters.component');
const { ProductFilterService } = require('./filter/product-filter.service');
const { zeroFilterResultsComponentDefinition } = require('./zero-filter-results.component');
const { tileListViewComponentDefinition } = require('./tile-list-view.component');
const { pastShopEverythingTileListComponentDefinition } = require('./past-shop-everything-tile-list.component');
const { listComponentDefinition } = require('./list.component');

angular.module('wowApp.shop')
    .constant('SortByKeys', sortByKeys)
    .constant('TileListViewLayout', tileListViewLayout)
    .service('ProductFilterService', ProductFilterService)
    .component('wowGhostTile', ghostTileComponentDefinition)
    .component('wowGhostList', ghostListComponentDefinition)
    .component('wowTileList', tileListComponentDefinition)
    .component('wowTileListView', tileListViewComponentDefinition)
    .component('wowPastShopEverythingTileList', pastShopEverythingTileListComponentDefinition)
    .component('wowTileListWithContent', tileListWithContentComponentDefinition)
    .component('wowTile', tileComponentDefinition)
    .component('wowList', listComponentDefinition)
    .component('wowProductFilter', productFilterComponentDefinition)
    .component('wowStringFilter', stringFilterComponentDefinition)
    .component('wowSelectedFilters', selectedFiltersComponentDefinition)
    .component('wowZeroFilterResults', zeroFilterResultsComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/tiles/index.js